import React, { MouseEvent, useEffect, useRef, useState } from "react";
import { ReactComponent as IconLang } from "../../assets/icons/language.svg";
import { defLangs, getLang, getLanguages } from "../../helpers/LangHelper";
import "./style.scss";
import { useTranslation } from "react-i18next";
import useClickOutside from "../../hooks/clickOutside";

const LanguageBlock = () => {
    const [t, i18n] = useTranslation();

    const langRef = useRef<HTMLDivElement>(null);
    useClickOutside(langRef, () => setIsOpen(false));

    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [languages, setLanguages] = useState<string[]>(defLangs);

    useEffect(() => {
        setLanguages(getLanguages());
    }, []);

    const changeLanguage = (e: MouseEvent, lang: string) => {
        e.stopPropagation();
        i18n.changeLanguage(lang);
        setIsOpen(false);
    }

    return <div ref={langRef} className="LanguageBlock" onClick={() => setIsOpen(!isOpen)}>
        <div className="text">{getLang().toUpperCase()}</div>
        <IconLang />

        <div className={`languages ${isOpen ? "" : "hide"}`}>
            {languages.map(x => <div key={`lang_${x}`} className={`lang ${i18n.language.toLowerCase().indexOf(x) !== -1 ? "active" : ""}`} onClick={(e) => changeLanguage(e, x)}>{t(`languages.${x}`)}</div>)}
        </div>
    </div>
}

export default LanguageBlock;